import { mdiMenuLeft, mdiMenuRight } from "@mdi/js";
import Icon from "@mdi/react";
import { Flex } from "antd";
import React from "react";
import Slider from "react-slick";
import Legends from "./Legends";
import { CRUISE_CATEGORY } from "../../utils/helpers";

const settings = {
  dots: false,
  arrows: true,
  slidesToShow: 7.5,
  pauseOnHover:false,
  speed: 500,
  infinite: false,
  slidesToScroll: 1,
  prevArrow: <Icon path={mdiMenuLeft} size={2} />,
  nextArrow: <Icon path={mdiMenuRight} size={2} />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5.5,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3.5,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.5,
        }
      },
    ]
 };


const TourDateSelector = (
  props: {
    dates: any[],
    selectedDate: string,
    selectedTourCode: any,
    selectTour: Function,
    category: string,
    isNew?: boolean
  }
) => {
  const { dates, selectedDate, selectedTourCode, selectTour, category } = props;
  const isCruise = category === CRUISE_CATEGORY;

  return (
    <>
      { !isCruise && <Legends />}

      <div className="tour-date-selector">
        <Slider {...settings}>
          {
            dates.map((tour:{ id?: number; date: string; code: string; type: string; price: string }) => {
              return <div key={tour.code} className={`date-box departure-date ${!isCruise && tour.type} ${(selectedDate ? (selectedDate == tour.date && selectedTourCode == tour.code) : selectedTourCode == tour.code) && "selected"}`} onClick={()=>selectTour(tour)}>
                <Flex justify="space-between" align="center" vertical gap={8}>
                  <div className="date-box_date"> {tour.date} </div>
                  <div>
                    <span>From</span>
                    <div className="date-box_price"> {tour.price} </div>
                  </div>
                </Flex>
              </div>
            })
          }
        </Slider>
      </div>
    </>
  );
};

export default TourDateSelector;